import styles from './BrandMark.module.css';

/**
 * The chimney sweep's brass button (touching one brings luck); its four holes read as a
 * calendar grid. Shown on the navy app bar, so no tile around it. Colours come from tokens.
 */
export function BrandMark({ size = 40 }: { size?: number }) {
  return (
    <svg className={styles.mark} width={size} height={size} viewBox="0 0 64 64" aria-hidden="true">
      <circle className={styles.button} cx="32" cy="32" r="28" />
      <circle className={styles.rim} cx="32" cy="32" r="21" />
      <circle className={styles.hole} cx="25.2" cy="25.2" r="4.6" />
      <circle className={styles.hole} cx="38.8" cy="25.2" r="4.6" />
      <circle className={styles.hole} cx="25.2" cy="38.8" r="4.6" />
      <circle className={styles.hole} cx="38.8" cy="38.8" r="4.6" />
    </svg>
  );
}
